import React, { Component } from 'react';
export default function DiIconbackArrow(props) {
  return React.createElement(
    "svg",
    {
      className: props.className,
      onClick: props.onClick,
      viewBox: "0 0 10 19"
    },
    React.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        {
          transform: "translate(-604.000000, -529.000000)"
          //   fill="#ffffff"
          , fillRule: "nonzero"
        },
        React.createElement("path", {
          d: "M613.315392,547.075589 L613.591614,546.799406 C613.774681,546.616377 613.774681,546.319556 613.591614,546.13649 L605.95518,538.500018 L613.591614,530.863546 C613.774681,530.680517 613.774681,530.383697 613.591614,530.20063 L613.315392,529.924446 C613.132363,529.741418 612.835581,529.741418 612.652514,529.924446 L604.408362,538.16856 C604.225295,538.351627 604.225295,538.648409 604.408362,538.831514 L612.652514,547.075628 C612.835581,547.258656 613.132363,547.258656 613.315392,547.075589 Z",
          transform: "translate(608.999988, 538.500035) rotate(-360.000000) translate(-608.999988, -538.500035) "
        })
      )
    )
  );
}